export const messages = {
  en: {
    adminWorkPool: {
      search: {
        title: 'Search Conditions',
        workName: 'Work Order Name',
        createUser: 'Creator',
        staffName: 'Handler',
        startTime: 'Start Time',
        endTime: 'End Time'
      },
      list: {
        title: 'Work Order Pool'
      },
      table: {
        id: 'ID',
        communityName: 'Community Name',
        workName: 'Work Order Name',
        typeName: 'Type Name',
        workCycle: 'Cycle',
        createUser: 'Creator',
        staffName: 'Handler',
        timeRange: 'Time Range',
        status: 'Status',
        createTime: 'Create Time',
        finishTime: 'Finish Time'
      },
      status: {
        timeout: 'Timeout'
      },
      workCycle: {
        once: 'One-time',
        periodic: 'Periodic'
      },
      community: {
        title: 'Community Selection',
        all: 'All Communities',
        fetchError: 'Failed to load communities'
      },
      fetchError: 'Failed to load work orders'
    }
  },
  zh: {
    adminWorkPool: {
      search: {
        title: '查询条件',
        workName: '工单名称',
        createUser: '发起人',
        staffName: '处理人',
        startTime: '开始时间',
        endTime: '结束时间'
      },
      list: {
        title: '工作单池'
      },
      table: {
        id: '编号',
        communityName: '小区名称',
        workName: '工单名称',
        typeName: '类型名称',
        workCycle: '标识',
        createUser: '发起人',
        staffName: '处理人',
        timeRange: '时间段',
        status: '状态',
        createTime: '创建时间',
        finishTime: '完成时间'
      },
      status: {
        timeout: '超时'
      },
      workCycle: {
        once: '一次性工单',
        periodic: '周期性工单'
      },
      community: {
        title: '小区选择',
        all: '全部小区',
        fetchError: '加载小区失败'
      },
fetchError: '加载工单失败'
    }
  },
  'zh-TW': {
    adminWorkPool: {
      search: {
        title: '查詢條件',
        workName: '工單名稱',
        createUser: '發起人',
        staffName: '處理人',
        startTime: '開始時間',
        endTime: '結束時間'
      },
      list: {
        title: '工作單池'
      },
      table: {
        id: '編號',
        communityName: '小區名稱',
        workName: '工單名稱',
        typeName: '類型名稱',
        workCycle: '標識',
        createUser: '發起人',
        staffName: '處理人',
        timeRange: '時間段',
        status: '狀態',
        createTime: '創建時間',
        finishTime: '完成時間'
      },
      status: {
        timeout: '超時'
      },
      workCycle: {
        once: '一次性工單',
        periodic: '周期性工單'
      },
      community: {
        title: '小區選擇',
        all: '全部小區',
        fetchError: '加載小區失敗'
      },
      fetchError: '加載工單失敗'
    }
  }
}